<template>
  <IQOSModal>
    <template #title> 
      {{$t('stats.import.file')}}
    </template>

    <div class="import-modal v1-grey-3-color gap-row-xs">
      <div class="qrw-paragraph-md">
         {{$t('stats.import.csv')}}
      </div>
      <div class="qrw-paragraph-md">
         {{$t('stats.import.max_size')}}
      </div>
      <div class="qrw-paragraph-md">
         {{$t('stats.import.must_consist_of')}}
      </div>
      <div class="qrw-paragraph-md">
        <a class="green-5-color" href="/docs/clients-import-example.csv">{{$t('stats.import.example')}}</a>
      </div>
      <p class="red-4-color qrw-paragraph-md" v-if="error">
        {{$t('stats.import.unable_to_import')}}
      </p>
      
      <input type="file" accept=".csv" @change="onFileSelected" v-show="false" ref="uploadInput" />
    </div>

    <template #actions>
      <BaseButton class="w-100" variant="secondary" size="md" color="v1-grey-7" @click="emitClose">{{$t('stats.import.close')}}</BaseButton>
      <BaseButton class="w-100" variant="secondary" size="md" color="v1-grey-3" @click="openImportDialog">{{$t('stats.import.choose')}}</BaseButton>
      
    </template>
  </IQOSModal>
</template>

<script>
import BaseModal from "@/components/modals/BaseModal.vue";

import StatsAPI from "@/api/stats";

export default {
  components: {
    BaseModal
  },
  data() {
    return {
      busy: false,
      error: false
    };
  },
  methods: {
    openImportDialog() {
      if (this.busy) return;

      this.$refs.uploadInput.click();
    },
    onFileSelected() {
      let csv_file = this.$refs.uploadInput.files[0];

      if (!csv_file) return;

      if (csv_file.size > 3 * 1024 * 1024) {
        alert("Файл занадто великий!");
        return;
      }

      this.busy = true;
      this.error = false;

      StatsAPI.importClients(csv_file)
        .then(response => {
          this.$refs.uploadInput.value = "";
          this.busy = false;

          if (!response.data.success) {
            this.error = true;
            return;
          }

          this.$emit("success");
        })
        .catch(error => {
          this.$refs.uploadInput.value = "";
          this.error = true;
        });
    },
    emitClose() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.controls {
  display: flex;
  justify-content: space-between;
}

a {
  text-decoration: none;
}
</style>